// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c61a2ccd","453":"ea9e6a9d","732":"e6daaf57"}[chunkId] + ".chunk.js";
};